export const TASK_DATE_FORMAT = 'yyyy-MM-dd';
export const TASK_RECTANGLE_COLOR = '#01152b';
export const TASK_RECTANGLE_ACTIVE_COLOR = '#12FFE2';
